export const ASSETS = 'assets';
export const ASSET_MODELS = 'asset-models';
export const GEOFENCES = 'geofences';
export const SUB_ORGS = 'sub-orgs';
export const USERS = 'users';
export const USER_PROFILES = 'user-profiles';
